import React from 'react'

import SmoothCollapse from 'react-smooth-collapse'
import ValidateResponse from 'components/validations/validate-response'

export default ({
    error
}) => {
    return (
        <SmoothCollapse
            expanded={!!error}
        >
            <ValidateResponse
                response={{
                    type: 'error',
                    message: error
                }}
                timeout={99999}
                dismissCallback={() => {}}
            />
        </SmoothCollapse>
    )
}


// WEBPACK FOOTER //
// ./src/components/form/formError.jsx